import React from 'react'
import clsx from 'clsx'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import styles from 'components/Navigation/Navigation.module.css'
import { ReactComponent as VislineLogotypeIcon } from 'assets/logos/visline.svg'
import { ReactComponent as VislineLogoIcon } from 'assets/logos/logo.svg'
import { NotificationMenuSwitch } from 'components/Notification'
import {IntegrationInfoField, LanguageSelectField} from 'components/Navigation'
import { NavigationList } from 'components/Navigation/NavigationList'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    display: 'flex',
    zIndex: 1200,
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: drawerWidth => `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth => drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 0
  },
  hide: {
    display: 'none',
  },
  drawer: {
    position: 'relative',
    width: drawerWidth => drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerPaper: {
    width: drawerWidth => drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: drawerWidth => -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}))

export function MobileNavigation ({ width, open, setOpen }) {
  const [notificationListOpen, setNotificationListOpen] = React.useState(false)

  const classes = useStyles(width)
  const theme = useTheme()

  const handleDrawerOpen = () => {
    setOpen(true)
  }

  const handleDrawerClose = () => {
    setOpen(false)
    setNotificationListOpen(false)
  }

  return (
    <div className={classes.root}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          className={clsx(classes.menuButton, open && classes.hide)}
        >
          <MenuIcon/>
        </IconButton>
      </Toolbar>
      <Drawer
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open
        })}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <div className={classes.toolbar}>
            <div className={open ? styles.logoBoxOpen : styles.logoBoxClosed}
                 style={{ transform: 'translateX(-19px)' }}>
              <div className={open ? styles.logotypeOpen : styles.logotypeClosed}>
                <VislineLogotypeIcon/>
              </div>
              <div className={styles.logo}>
                <VislineLogoIcon/>
              </div>
            </div>
          </div>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon/> : <ChevronRightIcon/>}
          </IconButton>
        </div>
        <NotificationMenuSwitch openNotifications={() => setNotificationListOpen(true)}
                                closeNotifications={() => setNotificationListOpen(false)}
                                notificationsOpen={notificationListOpen}/>
        <NavigationList notificationListOpen={notificationListOpen}
                        onListItemClick={handleDrawerClose}/>
        <div className={styles.languageButtons}>
          <IntegrationInfoField drawerOpen={open}/>
          <LanguageSelectField/>
        </div>
      </Drawer>
    </div>
  )
}
